<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@ds/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <th :class="cn('py-2.5 px-2 first:pl-4 last:pr-4 text-left align-middle [&:has([role=checkbox])]:pr-0 text-[10.5px] font-bold uppercase tracking-ds-caps text-muted-foreground', props.class)">
    <slot />
  </th>
</template>
